import { ComponentProps, SyntheticEvent } from 'react';

import {
  AreaChart,
  BarChart,
  ComposedChart,
  LineChart,
  ScatterChart,
} from 'recharts';

import { ChartType } from '../../types';

type AreaChartProps = ComponentProps<typeof AreaChart>;
type BarChartProps = ComponentProps<typeof BarChart>;
type LineChartProps = ComponentProps<typeof LineChart>;
type ScatterChartProps = ComponentProps<typeof ScatterChart>;
type ComposedChartProps = ComponentProps<typeof ComposedChart>;

export type ChartComponentProps = {
  area: AreaChartProps;
  bar: BarChartProps;
  line: LineChartProps;
  scatter: ScatterChartProps;
  composed: ComposedChartProps;
}[ChartType];

export const ChartComponentMap = {
  area: AreaChart,
  bar: BarChart,
  line: LineChart,
  scatter: ScatterChart,
  composed: ComposedChart,
};

export type ChartClickHandler = (
  chartState: {
    activeIndex?: number | string;
    activeCoordinate?: { x: number; y: number };
  },
  event: SyntheticEvent<Element, Event>
) => void;

export type BarConfig = {
  /**
   * Gap between bar categories.
   */
  barCategoryGap?: number | string;

  /**
   * Gap between individual bars in the same category.
   */
  barGap?: number | string;

  /**
   * Fixed bar width.
   */
  barSize?: number | string;

  /**
   * Maximum bar width.
   */
  maxBarSize?: number;
};
